import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { LayoutLogin } from '../layouts/LoginLayout';
import { useSearchParams } from 'react-router-dom';
import { API_URL } from '../config';

const TurnoCard = ({ casilla, historico }) => {
  const isDifferent = casilla.folio !== historico.find((h) => h.folio === casilla.folio)?.folio;
  const ultimo = isDifferent && casilla.estado === 'ocupado'
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
          height: '150px',
          borderRadius: '20px',
          backgroundColor: casilla.estado === 'libre' ? 'grey.500' : 'primary.main',
          //backgroundImage: casilla.estado === 'libre' ? 'none' : 'linear-gradient(0deg, rgba(0, 213, 255, 0.64) 20%, #83a4d4 80%, #83a4d4 100%)',
          position: 'relative',
          border: ultimo ? '5px solid #BC955B' : 'none',
        }}
      >
        <Typography
          variant="h5"
          color="primary.white"
          fontWeight={500}
        >
          Estación {casilla.casilla}
        </Typography>
        <CardContent>
          <Typography variant="h3" color="primary.white" fontWeight={500}>
            {casilla.folio || 'Libre'}
          </Typography>
        </CardContent>
      </Card>

      {ultimo && (
        <Typography
          variant="caption"
          color="primary.black"
        >
          Último en atención
        </Typography>
      )}
    </Box>
  );
};

const TurnoCardR = ({ folio, index }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%',
          height: '100px',
          borderRadius: '20px',
          backgroundColor: index === 0 ? 'grey.500' : 'grey.300',
        }}
      >
        <CardContent>
          <Typography variant="h5" color="primary.black" fontWeight={500}>
            {folio}
          </Typography>
        </CardContent>
      </Card>

      {index === 0 && (
        <Typography variant="h6" color="primary.black" fontWeight={500}>
          Siguiente turno
        </Typography>
      )}
    </Box>
  );
};

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const [atencion, setAtencion] = useState([]);
  const [espera, setEspera] = useState([]);
  const [historico, setHistorico] = useState([]);

  const getTurnos = async () => {
    try {
      const response = await fetch(`${API_URL}/turnos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ rol: type === 's' ? 'Signos' : 'Triage' }),
      });
      const data = await response.json();
      setAtencion(data.atencion);
      setEspera(data.espera);
      setHistorico(data.historico);
    } catch (error) {
      console.error(error);
    }
  };

  //UseEffect para obtener los turnos cada 10 segundos
  useEffect(() => {
    getTurnos();
    const interval = setInterval(() => {
      getTurnos();
    }, 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);


  //Funcion para generar sonido de notificacion
  // const playSound = () => {
  //   const audio = new Audio('/sounds/triage.mp3');
  //   audio.play().catch((error) => console.error('Error al reproducir el sonido:', error));
  // };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'left',
        flexDirection: 'column',
        height: '100%',
        minHeight: '100vh',
        width: '100%',
        p: 5,
        backgroundColor: type === 't' ? '#C1C1C1' : '#E5E5E5',
      }}
    >
      <Typography
        variant="h2"
        color="primary.black"
        my={2}
        sx={{
          fontFamily: 'Montserrat',
          fontWeight: 600,
        }}
      >
        Turnos de {type === 's' ? 'Signos Vitales' : 'Triage'}
      </Typography>

      {/* Turnos en proceso */}
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexDirection: 'column',
          borderRadius: '20px',
          p: 1,
          backgroundColor: 'primary.gold',
        }}
      >
        <Typography
          variant="h6"
          color="primary.white"
        >
          Turnos en proceso
        </Typography>
      </Card>

      <Grid container spacing={2} justifyContent="center" sx={{ width: '100%', height: '100%', mt: 2 }}>
        {atencion?.map((casilla) => (
          <Grid
            item
            xs={12}
            md={type === 's' ? 2.4 : 2.4}
            key={casilla.id}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <TurnoCard
              casilla={casilla}
              historico={historico}
            />
          </Grid>
        ))}
      </Grid>

      {/* Próximos turnos */}
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexDirection: 'column',
          borderRadius: '20px',
          marginTop: 10,
        }}
      >
        <Typography variant="h6" color="primary.black">
          Próximos turnos
        </Typography>
      </Card>

      <Grid container spacing={2} justifyContent="center" sx={{ width: '100%', height: '100%', mt: 2 }}>
        {espera?.map((turno, index) => (
          <Grid item xs={12} sm={6} md={2.4} key={turno.id} sx={{ display: 'flex', justifyContent: 'center' }}>
            <TurnoCardR folio={turno} index={index} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const Turno = () => {
  return (
    <LayoutLogin>
      <HomePage />
    </LayoutLogin>
  );
};

export default Turno;
